<template>
  <v-layout style="position: absolute; top: 0; left: 0px; right: 0; bottom: 0;">
    <v-col style="height: 100%; overflow-y: auto; max-width: 400px; min-width: 315px;">
      <v-list dense color="transparent">
        <v-subheader>Tags</v-subheader>
        <v-list-item v-for="tag in resourceTags" :key="tag.id">
          <v-checkbox
            v-model="selectedTags"
            :label="tag.text + `(${tag.resources ? tag.resources.length : 0})`"
            :value="tag"
            hide-details
            class="mt-1"
          ></v-checkbox>
        </v-list-item>
      </v-list>
    </v-col>
    <v-flex
      class="px-4"
      :style="
        `overflow-y: auto;
              overflow-x: hidden;
              height: 100%;`
      "
    >
      <v-layout>
        <div class="pt-2 pl-2">
          <v-btn icon><v-icon color="primary">add_circle</v-icon></v-btn>
        </div>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-layout>
      <v-data-table
        v-if="currentWorkspaceId"
        v-on:click:row="c.log($event)"
        class="transparent"
        show-select
        :search="search"
        :headers="[
          { text: 'Type', value: 'type' },
          { text: 'Name', value: 'text' },
          { text: 'Permission', value: 'permissions' },
          { text: 'Authors' },
          { text: 'Last Opened' },
          { text: 'Created On', value: 'createdOn' },
          { text: ' ' }
        ]"
        :items="resources"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
              :class="{ 'grey lighten-2': selectedItem == item.id }"
              @dblclick="selectedResourceId = item.id"
              @click="selectedItem = item.id"
              draggable="true"
              @dragstart.prevent="dragListItemStart(item.id, item.type, $event)"
              style="user-select: none;"
            >
              <td width="80">
                <v-icon v-if="item.resourceData.type == 'webpage'" size="16">web</v-icon>
                <v-icon v-else-if="item.resourceData.type == 'pdf'" size="16"
                  >picture_as_pdf</v-icon
                >
              </td>
              <td style="white-space: nowrap; overflow: hidden;max-width: 151px;">
                {{ item.resourceData.title || item.resourceData.name }}
              </td>
              <td>
                <v-icon v-if="item.userPermission == 'editing'" size="16">edit</v-icon>
                <c-icon v-else-if="item.userPermission == 'viewing'" icon="context" size="16"
                  >visibility</c-icon
                >
              </td>
              <td>
                <user-avatar
                  v-for="author in item.authors"
                  :avatarUrl="author.avatar"
                  :key="author.id"
                  size="24"
                ></user-avatar>
              </td>
              <td>{{ item.lastOpenedByUser | formatDate }}</td>
              <td>{{ item.createdOn | formatDate }}</td>
              <td width="180">
                <v-btn text v-if="selectedItem == item.id" @click="addToContext(item.id)">
                  Add To Context
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

import UserAvatar from '@/components/UserAvatar';

export default {
  components: { UserAvatar },
  props: ['space'],
  data() {
    return {
      c: console,
      search: null,
      selectedTags: [],
      selectedItem: null,
      selectedResourceId: null
    };
  },
  computed: {
    ...mapGetters('workspaces', ['currentWorkspace', 'workspaceContexts', 'userPermissionIds']),
    ...mapGetters('userWorkspaceLite', [
      'currentUserWorkspaceLite',
      // 'allUserDocuments',
      'workspaceResources'
    ]),
    ...mapState('userWorkspaceLite', ['allUserDocuments']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('workspaces', ['currentWorkspaceId']),
    dialog: {
      get() {
        return !!this.selectedResourceId;
      },
      set(v) {
        this.selectedResourceId = v;
      }
    },
    resources() {
      let w = this.workspaceResources;
      if (this.selectedTags.length) {
        let resourceIds = [];
        this.selectedTags.forEach(tag => {
          resourceIds = resourceIds.concat(tag.resources);
        });
        w = w.filter(resource => resourceIds.includes(resource.id));
      }
      return w;
    },
    resourceTags() {
      let t = this.currentWorkspace ? Object.values(this.currentWorkspace.resourceTags) : [];
      return t.sort((a, b) => (a.resources.length < b.resources.length ? 1 : -1));
    }
  },
  methods: {
    addToContext(id) {
      this.$emit('addToContext', id);
    }
  }
};
</script>

<style>
.workspace-panel .v-expansion-panel-content__wrap {
  width: 100%;
  padding-right: 0px;
}
</style>
